import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shareSite-box" }
const _hoisted_2 = { class: "shareSite-box__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chat" }, null, -1)
const _hoisted_4 = { class: "share-bar" }
const _hoisted_5 = { class: "input-wrap" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.$t('ShareSiteBox.header', { domain: _ctx.domain })), 1)
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('ShareSiteBox.message')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          type: "text",
          readonly: "",
          value: _ctx.sharing.url
        }, null, 8, _hoisted_6),
        _createElementVNode("button", {
          class: "button button--icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.sharing.url)))
        }, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
          return (_openBlock(), _createBlock(_component_ShareNetwork, {
            key: network.key,
            tag: "button",
            class: _normalizeClass(["button", network.classObject]),
            onOpen: _ctx.open,
            network: network.network,
            url: _ctx.sharing.url,
            title: _ctx.sharing.title,
            description: network.description
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(network.name), 1)
            ]),
            _: 2
          }, 1032, ["onOpen", "class", "network", "url", "title", "description"]))
        }), 128))
      ])
    ])
  ]))
}